import actions from './actions'

const initialState = {
  loading: false,
  regularSavings: [],
  summaryData: {},
  packageDetails: {},
  memberDetails: {},
  memberAutocomplete: [],
  savingsTransactions: [],
  withdrawalDetails: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
